let nav;

function navToggle(){
    const background_overlay = $('.header_overlay');

    if(nav.hasClass('active')){
        nav.removeClass('slide-left');
        nav.removeClass('slide-left--small');
        nav.removeClass('active');
        background_overlay.removeClass('active--2');
        $('body').css('overflow', 'visible');
        if($(window).width() > 500){
            nav.addClass('slide-right--small');
        }
        else{
            nav.addClass('slide-right');
        }
    }
    else{
        nav.removeClass('slide-right');
        nav.removeClass('slide-right--small');
        nav.addClass('active');
        $('body').css('overflow', 'hidden');
        background_overlay.addClass('active--2');
        if($(window).width() > 500){
            nav.addClass('slide-left--small');
        }
        else{
            nav.addClass('slide-left');
        }
    }
}

$(window).resize(
    function(){
        if($(window).width() > 1299){
            nav.removeClass('slide-left');
            nav.removeClass('slide-left--small');
            nav.removeClass('active');
            $('.header_overlay').removeClass('active--2');
            $('body').css('overflow', 'visible');   
        }
        else{
            if(nav.hasClass('active')){
                if($(window).width() > 500){
                    nav.removeClass('slide-left');
                    nav.addClass('slide-left--small');
                }
                else{
                    nav.removeClass('slide-left--small');
                    nav.addClass('slide-left');
                }
            }
        }
    }
);

function navChildrenToggle(version, item, element){
    if(version == 1){
        $('.'+item+'_accordion').slideToggle();
    }
    else if(version == 2){
        $('.menu_regular_accordion--'+item).slideToggle();
    }

    if($(element).hasClass('active')){
        $(element).removeClass('active');
    }
    else{
        $(element).addClass('active');
    }
}

(function myFunc(){
    nav = $('.nav');

    $('.mobile_nav_button').click(function(){
        navToggle();
    });

    $('.nav_svg').click(function(){
        navToggle();
    });

    $('.nav_item_title').on('click', (e) => {
        navChildrenToggle($(e.target).data('version'), $(e.target).data('item'), $(e.target))
    });
})();